import TextField from '@mui/material/TextField'
import { DatePicker } from '@mui/x-date-pickers/DatePicker'
import React from 'react'
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'
import { LocalizationProvider } from '@mui/x-date-pickers'
import deLocale from 'date-fns/locale/de'

interface Props {
  value: Date | null
  minDate?: Date
  maxDate?: Date
  onChange: (newValue: Date | null) => void
  width?: string
}

const BirthdayPicker = ({ value, minDate, maxDate, onChange, width = 'auto' }: Props) => {
  return (
    <div className="birthday-picker">
      <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={deLocale}>
        <DatePicker
          mask={'__.__.____'}
          openTo="year"
          views={['year', 'month', 'day']}
          label=""
          value={value}
          onChange={onChange}
          inputFormat={'dd.MM.yyyy'}
          renderInput={(params: any) => <TextField {...params} helperText={null} />}
          minDate={minDate ? minDate : undefined}
          maxDate={maxDate ? maxDate : new Date()}
        />
      </LocalizationProvider>
      <style global jsx>{`
        .birthday-picker {
          width: ${width};
        }
        .birthday-picker input {
          padding: 5px !important;
        }
        .birthday-picker .MuiIconButton-root {
          padding: 0;
          margin-top: 2px;
        }
        .birthday-picker fieldset {
          top: -10px;
        }
        .birthday-picker legend {
          width: 0;
        }
      `}</style>
    </div>
  )
}

export default BirthdayPicker
